import { RESET_TO_INITIAL_STATE } from '../actions/application';
import { reducer as appLoading } from './appLoading';
import { reducer as application } from './application';
import { reducer as assignment } from './assignment';
import { reducer as auth } from './auth';
import { reducer as checker } from './checker';
import { combineReducers } from 'redux';
import { reducer as heartbeat } from './heartbeat';
import { reducer as homework } from './homework';
import { reducer as mediaPlayer } from './media-player';
import { reducer as modal } from './modal';
import { reducer as report } from './report';
import { reducer as status } from './status';
import { reducer as theory } from './theory';
import { reducer as googleAuth } from './google-auth';

const appReducer = combineReducers({
    appLoading,
    auth,
    assignment,
    checker,
    heartbeat,
    homework,
    status,
    application,
    mediaPlayer,
    modal,
    report,
    theory,
    googleAuth,
});

const rootReducer = (state, action) => {
    if (action.type === RESET_TO_INITIAL_STATE) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
